import { render, staticRenderFns } from "./StatisticWorkersPanel.vue?vue&type=template&id=70e977d8&scoped=true&lang=pug&"
import script from "./StatisticWorkersPanel.vue?vue&type=script&lang=js&"
export * from "./StatisticWorkersPanel.vue?vue&type=script&lang=js&"
import style0 from "./StatisticWorkersPanel.vue?vue&type=style&index=0&id=70e977d8&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e977d8",
  null
  
)

export default component.exports